<template>
  <div class="comp_body">
    <div v-show="!show_chapters">
      <!-- <pre class="player_log"  v-show="false">{{ log }}</pre> -->
      <pre class="player_data" v-show="false">
      current_path: {{ current_path }}

      asset_id PROP: {{ asset_id }}
      direct: {{ direct }}

      is_playing: {{ is_playing }},
      next_time_to_save: {{ next_time_to_save}}
      </pre>
      <img class="comp_x link" v-on:click="prepare_hide(); $emit('show-assets')" src="/static/img/X.svg" />
      <img class="player_cover" v-bind:src="this.image_url" />
      <div class="player_title">{{ current_path.title }}</div>
      <div class="player_timeremaining">{{ time_remaining }}</div>
      <div class="player_slider air centerdiv">
        <vue-slider ref="slider" v-model="sec_pos_slider" v-bind="slider_config" v-on:drag-end="on_drag_end"  v-on:drag-start="on_drag_start"></vue-slider>
      </div>
      <div class="player_controls">
        <!--
        <div v-on:click="backward(30)"            class="link air audio_btn2" style="content: url(/static/img/30_tv.svg);"></div>
        <div v-show="is_playing" v-on:click="on_pause_click" class="link air audio_btn" style="content: url(/static/img/pause.svg);"></div>
        <div v-show="!is_playing" v-on:click="on_play_click"    class="link air audio_btn" style="content: url(/static/img/play.svg);"></div>
        <div v-on:click="forward(30)"             class="link air audio_btn2" style="content: url(/static/img/30_th.svg);"></div>
        -->
        <img v-on:click="backward(30)"            class="link air audio_btn2" src="/static/img/30_tv.svg" />
        <img v-show="is_playing" v-on:click="on_pause_click" class="link air audio_btn" src="/static/img/pause.svg" />
        <img v-show="!is_playing" v-on:click="on_play_click"    class="link air audio_btn" src="/static/img/play.svg" />
        <img v-on:click="forward(30)"             class="link air audio_btn2" src="/static/img/30_th.svg" />
      </div>
      <div class="air centerdiv">{{ chapter_title }}</div>

      <div class="player_toc link" v-on:click="show_chapters=true">Efnisyfirlit</div>

      <video v-show="false" id="dom_player" controls="controls" width="100px" height="50px"
        webkit-playsinline="true"
        playsinline="true"
      ></video>
    </div>
    <div class="fullscreen chapters" v-show="show_chapters">
      <div class="comp_title">
          EFNISYFIRLIT
      </div>
      <img class="comp_x link" v-on:click="show_chapters=false" src="/static/img/X.svg">
      <div class="chapters_list">
        <div class="chapter link" v-for="path in paths"
            v-bind:class="{ chapter_selected: current_path.path_id === path.path_id}"
        >
          <div v-on:click="on_chapter_path_id_selected(path.path_id);show_chapters=false"
          >
            <div class="chapter_title">{{ path.title }}</div>
            <div class="chapter_bar">
              <div class="progress_bar">
                <div class="progress_done" v-bind:style="'width: ' + parseInt(100 * path.sec_chapter_pos / path.sec_chapter_total) + '%;'"></div>
              </div>
              <div class="chapter_time">{{ digital_time(path.sec_chapter_total) }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import * as storage from '../storage'
/* eslint-disable camelcase */
import * as srv from '../srv'
import * as url from '../url'
import Hls from 'hls.js'
import vueSlider from 'vue-slider-component'
import * as storage from '../storage'

function pad (num, size) {
  let s = '000000000' + num
  return s.substr(s.length - size)
}
let dom_player
let hls
// console.log('script in Player.vue')
export default {
  components: {
    vueSlider
  },
  watch: {
  },
  data () {
    return {
      // log: '',
      show_chapters: false,
      paths: [],
      paths_by_id: {},
      current_path: {},
      direct: false,
      image_url: '',
      asset_id: '',
      setup_events_done: false,

      time_remaining: '',
      do_update_ui: true,
      is_playing: false,
      sec_pos_slider: 0,
      duration: 0,
      chapter_title: '',
      chapter_id: '',
      next_chapter_id: '',
      next_chapter_title: '',
      next_time_to_save: 0,
      play_allowed: false,
      slider_config: {
        value: 1,
        width: 300,
        height: 6,
        dotHeight: 20,
        dotWidth: 20,
        min: 0,
        max: 25,
        // interval: 1,
        disabled: false,
        show: true,
        speed: 0.3,
        reverse: false,
        lazy: true,
        tooltip: 'hover',
        piecewise: false,
        formatter (all_secs) {
          let secs = all_secs % 60
          let all_mins = (all_secs - secs) / 60
          let mins = all_mins % 60
          let hours = (all_mins - mins) / 60
          if (hours > 0) {
            return pad(hours, 2) + ':' + pad(mins, 2) + ':' + pad(secs, 2)
          } else {
            return pad(mins, 2) + ':' + pad(secs, 2)
          }
        },
        processStyle: {
          backgroundColor: '#9f0811'
        },
        tooltipStyle: {
          backgroundColor: '#9f0811',
          borderColor: '#9f0811'
        },
        // tooltipStyle: [
        //   {
        //     backgroundColor: '#9f0811',
        //     borderColor: '#9f0811'
        //   }
        // ],
        // bgStyle: {
        //   backgroundColor: '#660'
        // },
        clickable: false

      }
    }
  },
  mounted () {
    // console.log('mounted in Player.vue')
    dom_player = document.getElementById('dom_player')
    window.p = dom_player
    if (dom_player.canPlayType('application/vnd.apple.mpegurl') === 'probably' ||
        dom_player.canPlayType('application/vnd.apple.mpegurl') === 'maybe') {
      this.direct = true
    } else {
      this.direct = false
    }
  },
  methods: {
    // set_current_path_by_id (path_id) {
    //   this.current_path_index = 0
    //   this.current_path = this.paths.find(p => {
    //     this.current_path_index += 1
    //     return p.path_id === path_id
    //   })
    //   if (!this.current_path) {
    //     this.current_path = {}
    //   }
    // },
    // set_next_current_path () {
    //   this.current_path_index = this.current_path_index + 1
    //   if (this.paths.length === this.current_path_index) {
    //     this.current_path = {}
    //   } else {
    //     this.current_path = this.paths[this.current_path_index]
    //   }
    // },
    // play_path_current_path () {
    //   dom_player.pause()
    // },
    //  select_chapter_from_chapters (chapter_id) {
    //    this.show_chapters = false
    //    this.sec_pos = 0
    //    // this.next_time_to_save = 0
    //    this.get_chapter_data(this.asset_id, chapter_id, this.play)
    //  },
    on_chapter_path_id_selected (path_id) {
      // this.log = 'on_chapter_path_id_selected: new path' + path_id
      this.current_path = this.paths_by_id[path_id]
      if (this.current_path.sec_chapter_total < this.current_path.sec_chapter_pos + 5) {
        this.current_path.sec_chapter_pos = 0
      }
      this.setup()
    },
    setup_paths (asset_id, image) {
      this.asset_id = asset_id
      this.image_url = `https://hlusta.forlagid.is/i/${image}/cover-300@1x.png`
      srv.get_paths(this.asset_id)
        .then(data => {
          this.paths = data.paths
          this.paths_by_id = {}
          var last_path
          for (let i = 0; i < data.paths.length; i += 1) {
            let p = data.paths[i]
            this.paths_by_id[p.path_id] = p
            if (last_path) {
              last_path.next_path_id = p.path_id
              this.paths_by_id[last_path.path_id].next_path_id = p.path_id
            }
            last_path = p
          }
          if (data.current_path_id) {
            this.current_path = this.paths_by_id[data.current_path_id]
          } else {
            this.current_path = this.paths[0]
          }
          this.setup()
        })
        .catch(srv_err => {
          this.$emit('dialog-message', srv_err.error_text, () => {})
        })
    },
    prepare_hide () {
      this.pause()
      this.play_allowed = false
      // dom_player.src = ''
      // dom_player.load()
    },
    on_pause_click () {
      this.do_update_ui = true
      this.pause()
    },
    pause () {
      dom_player.pause()
    },
    on_play_click () {
      this.play_allowed = true
      this.do_update_ui = true
      this.play()
    },
    play () {
      if (this.play_allowed) {
        dom_player.play()
      }
    },
    save_current_time () {
      // this.next_time_to_save = this.sec_pos + 5
      this.next_time_to_save = dom_player.currentTime + 5
      let the_time = parseInt(dom_player.currentTime)
      srv.save_current_time(this.asset_id, this.current_path.path_id, the_time)
        .then(() => {
          this.current_path.sec_chapter_pos = the_time
        })
        .catch(srv_err => {
          // console.log(srv_err)
          if (srv_err.error_code === 'ANOTHER_DEVICE_IS_LISTENING') {
            this.pause()
            this.$emit('dialog-message', 'Ó nei.<br>Núna er annar notandi er að hlusta á bókina þína.  <br>Reyndu síðar.', () => {
              this.$emit('get-assets')
              this.$emit('show-assets')
            })
          }
        })
    },
    render_time_remaining (secs_float) {
      let all_secs = parseInt(secs_float)
      let secs = all_secs % 60
      let all_mins = (all_secs - secs) / 60
      let mins = all_mins % 60
      let hours = (all_mins - mins) / 60
      let str = ''
      if (hours > 0) {
        str = `${hours} klst. eftir`
      } else if (mins > 0) {
        str = `${mins} mín. eftir`
      } else if (secs > 0) {
        str = `${secs} sek. eftir`
      }
      return str
    },
    setup_events () {
      if (!this.setup_events_done) {
        this.setup_events_done = true
        // dom_player.addEventListener("ended", new_chapter);
        dom_player.addEventListener('play', () => {
          this.is_playing = true
        })
        dom_player.addEventListener('pause', (e) => {
          window.e = e
          // console.log('paused')
          if (this.do_update_ui) {
            this.is_playing = false
          }
        })
        // dom_player.addEventListener('loadedmetadata', (e, e2) => {
        //   console.log('loadedmetadata', e, e2)
        // })
        dom_player.addEventListener('durationchange', (e, e2) => {
          this.duration = dom_player.duration
          if (this.sec_pos_slider > parseInt(dom_player.duration)) {
            this.sec_pos_slider = parseInt(dom_player.duration)
          }
          this.slider_config.max = parseInt(dom_player.duration)
          // this.log = `durationchange: dom_player.duration:${parseInt(dom_player.duration)} \n` + this.log
        })
        dom_player.addEventListener('timeupdate', (e, e2) => {
          if (!dom_player.paused) {
            this.sec_pos_slider = parseInt(dom_player.currentTime)
            this.time_remaining = this.render_time_remaining(this.duration - dom_player.currentTime)
            if (this.next_time_to_save < dom_player.currentTime) {
              this.save_current_time()
            }
          }
          if (parseInt(dom_player.currentTime) !== this.last_timeupdate) {
            // this.log = `currentTime:${parseInt(dom_player.currentTime)}, next_time_to_save:${parseInt(this.next_time_to_save)} \n` + this.log
          }
          this.last_timeupdate = parseInt(dom_player.currentTime)
        })
        dom_player.addEventListener('ended', () => {
          // console.log('ended')
          // this.log = 'in dom_player event ended\n' + this.log
          this.do_update_ui = false
          // console.log(this.current_path)
          if (this.current_path.next_path_id) {
            this.current_path = this.paths_by_id[this.current_path.next_path_id]
            this.current_path.sec_chapter_pos = 0
            this.sec_pos_slider = 0
            this.next_time_to_save = 0
            this.setup()
          }
        })
      }
    },
    setup () {
      if (this.direct) {
        dom_player.setAttribute('autoplay', 'true')
        dom_player.currentTime = 0
        dom_player.setAttribute('src', this.get_url())
        dom_player.oncanplay = () => {
          dom_player.currentTime = this.current_path.sec_chapter_pos
          this.next_time_to_save = this.current_path.sec_chapter_pos + 5
          this.sec_pos_slider = parseInt(this.current_path.sec_chapter_pos)
          dom_player.play()
        }
      } else {
        if (Hls.isSupported()) {
          if (!hls) {
            hls = new Hls()
          }
          hls.loadSource(this.get_url())
          hls.attachMedia(dom_player)
          hls.on(Hls.Events.MANIFEST_PARSED, function () {
            dom_player.play()
          })
          // this.log = `playing from sec_chapter_pos:${this.current_path.sec_chapter_pos} \n` + this.log
          dom_player.currentTime = this.current_path.sec_chapter_pos
          this.next_time_to_save = this.current_path.sec_chapter_pos + 5
          // this.log = `setting next_time_to_save to:${this.next_time_to_save} \n` + this.log
        }
      }
      this.setup_events()
    },
    forward (sec) {
      if (dom_player.currentTime < dom_player.duration - 2) {
        var new_time = dom_player.currentTime + sec
        if (dom_player.duration - 2 <= new_time) {
          new_time = dom_player.duration - 2
        }
        dom_player.currentTime = new_time
        this.next_time_to_save = new_time
      }
    },
    backward (sec) {
      var new_time = dom_player.currentTime - sec
      if (new_time < 0) {
        new_time = 0
      }
      this.next_time_to_save = new_time
      dom_player.currentTime = new_time
    },
    on_drag_end (e) {
      // this.log = `on_drag_end: e:${parseInt(e.getValue())} \n` + this.log
      // this.log = `on_drag_end: dom_player.currentTime:${dom_player.currentTime} \n` + this.log
      // console.log(dom_player.currentTime, parseInt(e.getValue()))
      this.next_time_to_save = parseInt(e.getValue())
      dom_player.pause()
      dom_player.currentTime = parseInt(e.getValue())
      dom_player.play()
      // this.log = `on_drag_end: e:${parseInt(e.getValue())} \n` + this.log
      // this.log = `on_drag_end: dom_player.currentTime:${dom_player.currentTime} \n` + this.log

      // console.log(dom_player.currentTime, parseInt(e.value))
      // this.play()
      // console.log(dom_player.currentTime, parseInt(e.value))
    },
    on_drag_start (e) {
      // console.log(e.value)
      // this.pause()
    },
    get_url () {
      return `${url.stream}${storage.get_browser_id()}/${this.current_path.path_id}/s.m3u8`
    },
    str_pad_left (string, pad, length) {
      return (new Array(length + 1).join(pad) + string).slice(-length)
    },
    digital_time (secs_total) {
      let hours = Math.floor(secs_total / 3600)
      let mins = Math.floor((secs_total % 3600) / 60)
      let secs = (secs_total % 3600) % 60
      return this.str_pad_left(hours, '0', 2) + ':' + this.str_pad_left(mins, '0', 2) + ':' + this.str_pad_left(secs, '0', 2)
    }
  }
}
</script>


<style>
.slider_remaining{
  margin: auto;
  max-width: 300px;
}

.slider_remaining .remaining{
  width: 120px;
  text-align: right;
}

.fullscreen {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  z-index: 999;
  background: #fff;
}
pre {
  text-align: left;
}

/*.vue-slider-component .vue-slider {
		border-radius: 0 !important;
		background-color: #0c0 !important;
	}
*/
.vue-slider, .vue-slider-process, .vue-slider-dot {
		border-radius: 1 !important;
}
	/*	background-color: #000 !important; */
.audio_btn {
  width: 75px;
  height: 40px;
}
.audio_btn2 {
  height: 30px;
}

</style>




// WEBPACK FOOTER //
// src/components/Player.vue